import { render, staticRenderFns } from "./CoinsPurchasedHistoryList.vue?vue&type=template&id=2947472a&scoped=true&"
import script from "./CoinsPurchasedHistoryList.vue?vue&type=script&lang=ts&"
export * from "./CoinsPurchasedHistoryList.vue?vue&type=script&lang=ts&"
import style0 from "./CoinsPurchasedHistoryList.vue?vue&type=style&index=0&id=2947472a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2947472a",
  null
  
)

export default component.exports